import { ArrowRight } from "lucide-react";
import { Screen } from "../components/Screen";
import { Reveal } from "../components/Reveal";
import { Ref } from "../components/Ref";
import { Placeholder } from "../components/Placeholder";
import { useSnak, type RefTarget } from "../snak/SnakContext";
import { mintResultsDetail, clinicalEvidenceDetail } from "../content/details";
export function P8Invitation() {
  const {
    openDetail,
    openRefs
  } = useSnak();
  const links: {
    label: string;
    target: RefTarget;
  }[] = [{
    label: "Full references",
    target: null
  }, {
    label: "Study limitations",
    target: "limitations"
  }, {
    label: "Prescribing & safety information",
    target: "pi"
  }];
  return <Screen overline="The invitation" footnote={<p data-id="element-636" data-mp="1c2lrx193a55j">
          MINT is an observational, non-randomised study; figures are provisional and subject to verification against the
          full final study materials.<Ref n={1} data-id="element-637" data-mp="24l0vuckxjspm" /> No superiority over other treatments is implied. Concept prototype — not
          approved HCP promotional material. For healthcare professionals in Germany, Austria and Switzerland.{" "}
          <Placeholder data-id="element-638" data-mp="d467sevmanqq">job code, date of preparation</Placeholder>
        </p>} data-id="element-635" data-mp="1c46kwmfr9g1a">
      <Reveal delay={0.1} data-id="element-639" data-mp="qvbc3u9xk47e">
        <h1 className="mt-8 font-display text-[46px] font-medium leading-[1.02] tracking-[-0.015em]" data-id="element-640" data-mp="qvkrknxcmsyu">
          New evidence deserves <em className="font-medium text-[var(--s-accent)]" data-id="element-641" data-mp="m1qa7r57uq2x">a closer look.</em>
        </h1>
      </Reveal>
      <Reveal delay={0.2} data-id="element-642" data-mp="vtcvyhf6k7jx">
        <p className="mt-5 text-[17px] leading-relaxed" data-id="element-643" data-mp="vu5tqsw5vmpx">
          Explore the full findings and their relevance to appropriate care for patients with MF and SS.
        </p>
      </Reveal>

      <Reveal delay={0.35} data-id="element-644" data-mp="15r0r38gp7h2m">
        <div className="mt-9 flex flex-col gap-3" data-id="element-645" data-mp="15svdkr7mbh8t">
          <button onClick={() => openDetail(mintResultsDetail)} className="group flex h-14 items-center justify-between rounded-full bg-[var(--s-fg)] px-6 text-[13px] font-semibold uppercase tracking-[0.16em] text-[var(--s-bg)] transition-opacity duration-150 hover:opacity-90" data-id="element-646" data-mp="3bkim4m9wo3gk">
            Explore MINT Results
            <ArrowRight className="h-5 w-5 transition-transform duration-150 group-hover:translate-x-0.5" strokeWidth={1.75} data-id="element-647" data-mp="1fi5gjpqlc6jm" />
          </button>
          <button onClick={() => openDetail(clinicalEvidenceDetail)} className="flex h-14 items-center justify-between rounded-full border border-[var(--s-fg)] px-6 text-[13px] font-semibold uppercase tracking-[0.16em] transition-colors duration-150 hover:bg-white/10" data-id="element-648" data-mp="1pfjvfkwv8n9t">
            Review Clinical Evidence
            <ArrowRight className="h-5 w-5" strokeWidth={1.75} data-id="element-649" data-mp="237zs83z6bp2a" />
          </button>
        </div>
      </Reveal>

      <Reveal delay={0.5} data-id="element-650" data-mp="284q7wq72gin6">
        <ul className="mt-9 border-t border-[var(--s-rule)]" data-id="element-651" data-mp="288475pkfobqe">
          {links.map(({
          label,
          target
        }) => <li key={label} className="border-b border-[var(--s-rule)]" data-id="element-652" data-mp="2d3b7cnehuyak">
              <button onClick={() => openRefs(target)} className="group flex w-full items-center justify-between gap-3 py-3.5 text-left text-[15px]" data-id="element-653" data-mp="2h6zg39ev3zxe">
                {label}
                <ArrowRight className="h-4 w-4 opacity-70 transition-transform duration-150 group-hover:translate-x-0.5" strokeWidth={1.5} data-id="element-654" data-mp="1k5900kcj148" />
              </button>
            </li>)}
        </ul>
      </Reveal>
    </Screen>;
}